import { makeAutoObservable } from "mobx"
import ConvoAPI from '../api/convo';
import { RootStoreType, TransportLayerType } from "../stores/root_store";

export type CommentProps = {
	key: string;
	convo: string;
	content: string;
	date_created: string;
	unread: boolean;
	author: string; // "user", "chat-gpt3",
	user: string;
	attachment?: {
		type: string;
		fileName: string;
		size: string;
	};
	updateProps: (attributes: CommentProps) => void;
};


export class CommentsStore {
	comments = [] as Comment[]
	rootStore : RootStoreType
	transport
	LOADED_COMMENTS = [] as string[]
	USE_CACHE = true

	constructor(rootStore : RootStoreType, transport : TransportLayerType) {
		makeAutoObservable(this, {
			rootStore: false,
			transport: false,
			LOADED_COMMENTS: false,
			USE_CACHE: false
		})
		this.rootStore = rootStore
		this.transport = transport

	}

	_receiveUpdate(json : CommentProps) {
		const comment = this.comments.find((c) => c.key === json.key)
		if(comment) {
			if(comment.updateProps) {
				comment.updateProps(json)
			}
		} else {
			this.comments.push(new Comment(json))
		}

	}

	/* receiveUpdate(json: TransportLayerUpdateType) {
		if(Array.isArray(json)) {
			json.forEach((c) => this._receiveUpdate(c as CommentProps))
		}
		else {
			this._receiveUpdate(json as CommentProps)
		}
	} */

	send(projectKey: string, convoKey : string, content : string) {
		// // from ../api/convo
		return ConvoAPI.sendComment(projectKey, convoKey, content)
			.then((commentFromServer) => {
				//this.receiveUpdate(commentFromServer);
				return commentFromServer;
			})
			.catch((err) => {
				console.log(err);
			});

	}

	loadComments(convoKey : string) {
        if(this.USE_CACHE && this.LOADED_COMMENTS.includes(convoKey)) {
			console.info("Previous loaded these comments, doing nothing (%s)", convoKey);
			return;
		}

	/* 	// // from ../api/convo
		ConvoAPI.loadCommentList(convoKey)
			.then((comments) => {
				this.LOADED_COMMENTS.push(convoKey);

			})
			.catch((err) => {
				console.error("There was an error loading comments");
				console.error(err);
			}); */
	}

    getComments(convoKey : string) {
        return this.rootStore.commentsStore.comments.filter(comment => comment.convo === convoKey).sort((a, b) => {
 			return a.date_created > b.date_created ? 1 : -1;
 		});
    }


}






// Domain object Comment.
export class Comment implements CommentProps {

	key  = "";
	convo = "";
	content = "";
	date_created = "";
	unread = false;
	author = "user"; // "user", "chat-gpt3",
	user = ""

	constructor(attributes: CommentProps) {
		makeAutoObservable(this, {
			updateProps: false,
            // store: false,
            // autoSave: false,
            // saveHandler: false,
            // dispose: false
		})
		this.updateProps(attributes);
	}

    updateProps(attributes : CommentProps) {
		this.key = attributes.key;
		this.convo = attributes.convo;
		this.content = attributes.content;
		this.date_created = attributes.date_created;
		this.unread = attributes.unread;
		this.author = attributes.author;
		this.user = attributes.user;
	}
}
